import React from 'react';
import { Auth } from "./auth/Auth";
import App from "./App";
import AIApolloProvider from "./apollo/AIApolloProvider";
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './styles/theme';

const Root = props => {

    return (
        <ThemeProvider theme={theme}>
            <Auth>
                <AIApolloProvider>
                    <App />
                </AIApolloProvider>
            </Auth>
        </ThemeProvider>
    )
};

export default Root;
